module.exports = __webpack_public_path__ + "75b8811c7f254b56dc42ea2dca2c4742.pdf";